import React, { useContext, useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import '../ProductList.css';
import { useNavigate } from 'react-router-dom';
import Slider from './Silder';

import { CartContext } from "../CartContext";
import AdultSlider from './AdultSlider';

const AdultAccessories = () => {
  const { setEmail } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cart, setCart] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const inputRef = React.useRef(null);
  const [color, setColor] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedTags, setSelectedTags] = useState({

    // "Backbacks":false,
    "Duffels": false,
    // "Travel":false,
    // "Messengers":false,
    "Cinch Pack": false,
    "Totes": false,
    Backpacks: false,
    "Blankets": false,
    "Aprons": false,
    "Scarves": false,
    // "others":false,

    // Backpacks: false,

    'Towels': false,
    // Caps: false,
    Beanies: false, Hats: false,



  });


  const [sliderValue, setSliderValue] = useState(5.3);
  const itemsPerPage = 12;
  const navigate = useNavigate();

  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);

  // Load CSV Data
  const loadCSV = async () => {
    const csvUrl = './adult-accessories-list-menu.csv'; // Adjust the path

    try {
      const response = await fetch(csvUrl);
      if (!response.ok) throw new Error('Failed to load CSV file');
      const csvData = await response.text();

      Papa.parse(csvData, {
        complete: (result) => {
          const data = result.data;
          const parsedProducts = data.slice(1).map((item) => ({
            Handle: item[28],
            ColorVal: item[33],
            Size: item[14],
            DefaultImageSrc: item[2],
            HoverImageSrc: item[23],
            Price: parseFloat(item[1]),
            Description: item[3],
            Style: item[13],
            Tags: item[6]?.split(',').map(tag => tag.trim()) || [], // Ensure tags are split and cleaned up
          }));

          setProducts(parsedProducts);
          setFilteredProducts(parsedProducts);
          setLoading(false);
        },
        header: false,
        skipEmptyLines: true,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCSV();
  }, []);

  // const subs = () => {
  //   const emailValue = inputRef.current.value;
  //   if (emailValue) {
  //     setEmail(emailValue);  // Set email value in the context
  //     inputRef.current.value = "";  // Clear the input field after setting
  //   }
  // }

  // Add to cart functionality
  const handleAddToCart = (product) => {
    navigate(`/product-adult/${product.Style}`);
  };

  // Apply filters, search, and sorting
  useEffect(() => {
    let updatedProducts = [...products];


    // Filter by color
    if (color) {
      updatedProducts = updatedProducts.filter(product =>
        product.ColorVal.split(',').some(c => c.trim().toLowerCase().includes(color.toLowerCase()))
      );
    }
    // Filter by tags
    const selectedTagKeys = Object.keys(selectedTags).filter(tag => selectedTags[tag]);
    if (selectedTagKeys.length > 0) {
      updatedProducts = updatedProducts.filter(product =>
        selectedTagKeys.some(tag => product.Tags.includes(tag))
      );
    }

    // Filter by search term
    if (searchTerm) {
      updatedProducts = updatedProducts.filter(product =>
        product.Handle.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.Description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Sort by price
    const maxPrice = Math.max(...products.map(p => p.Price));
    const minPrice = Math.min(...products.map(p => p.Price));
    const targetPrice = minPrice + ((maxPrice - minPrice) * sliderValue) / 100;
    updatedProducts.sort((a, b) => {
      const diffA = Math.abs(a.Price - targetPrice);
      const diffB = Math.abs(b.Price - targetPrice);
      return diffA - diffB || a.Price - b.Price;
    });

    setFilteredProducts(updatedProducts);
  }, [products, selectedTags, searchTerm, sliderValue, color]);

  // Pagination logic
  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when search term changes
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1); // Reset to first page when tag filter changes
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <>
      {/* <h3>Under Development (Test mode)</h3> */}
      <div className="product-list-container">

        {/* Sidebar with Filters */}
        <div className="sidebar">
          <div className="sidebar-content">
            {/* <div style={{ textAlign: "center" }}>
               <a style={{ color: "white", textDecoration: "none", }} href="/about-us">
                 <p style={{ fontSize: 15, margin: "auto", marginBottom: 10 }}>
                   ABOUT US
                 </p>
               </a>
             </div> */}
            <div className="slider-container" style={{ marginLeft: -5, alignItems: 'center', width: "100%", }}>
              <AdultSlider width={"100%"}
                height={130} />

            </div>

            {/* Search Box */}
            <div className="search-box">
              <h6 style={{ marginTop: -15, marginLeft: 5, }}>Categories</h6>
              <input
                type="text"
                style={{ fontSize: 8 }}
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by name..."
              />
            </div>

            {/* Tag Filters */}
            <div className="checkbox-filters">
              {Object.keys(selectedTags).map(tag => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
            </div>
          </div>
          <hr style={{ marginTop: -20, marginBottom: 0 }} />
          <div className="slider-container" style={{ textAlign: "center", }}>
            <label htmlFor="price-slider">Sort by Price</label>
            <input
              type="range"
              id="price-slider"
              min="0"
              max="100"
              value={sliderValue}
              onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
            />
            <div className="labels" style={{ marginBottom: -15 }}>
              <span className="low">$2</span>
              <span className="high">$360</span>
            </div>
          </div>
          <hr style={{ marginTop: -10, marginBottom: 0 }} />
          {/* <div className="email" style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             flexDirection: "column",
             width: "100%",
             boxSizing: "border-box"
           }}>
             <input
               ref={inputRef}
               style={{
                 fontSize: "9px",
                 width: "100%",
                 maxWidth: "300px",
                 height: "28px",
                 padding: "2px",
                 marginBottom: "-5px",
                 borderRadius: "15px",
                 border: "2px, solid, white"
               }}
               type="email"
               placeholder='Get notified on our sales'
             />
 
             <button onClick={subs} style={{ backgroundColor: "black", color: "white", borderRadius: 15, fontWeight: "bold", marginBottom: 10, height: 30, width: "100%", maxWidth: 200, marginTop: 10 }}>SUBSCRIBE</button>
 
           </div> */}
          {/* <div style={{ textAlign: "center", maxWidth:190}}>
             <label style={{marginBottom:10}}>Search by Color</label>
             <input placeholder="Saerch by color" style={{border:"none",fontSize:14, height:40, textAlign:"center",width:"100%", borderRadius:5}} type="text" OnChange={(e) => setColor(e.target.value)}></input>
           </div> */}
        </div>

        {/* Main Content (Product Grid) */}
        <div className="product-grid">
          {currentProducts.length > 0 ? (
            currentProducts.map((product, index) => (
              <div key={index} className="product-card"
                onClick={() => handleAddToCart(product)}
              >

                <div className="image-container">
                  <img
                    src={product.DefaultImageSrc}
                    alt={product.Handle}
                    className="product-image default-image"
                  />
                  <img
                    src={product.HoverImageSrc}
                    alt={`${product.Handle} Hover`}
                    className="product-image hover-image"
                  />
                </div>
                <div className="product-details">
                  <h3 className="product-handle">{product.Handle}</h3>
                  <p className="product-price">Price: From ${product.Price}</p>
                </div>
                <div className="product-details2">
                  {product.Size}
                </div>
              </div>
            ))
          ) : (
            <p>No products available.</p>
          )}
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <img src="/images/assets/arrowFirs.png" style={{ maxWidth: 35, marginRight: -35 }} alt="First" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img src="/right-arrow.png" style={{ maxWidth: 35 }} alt="Next" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <img src="/images/assets/arrowLast.png" style={{ maxWidth: 35, marginLeft: -35 }} alt="Last" />
        </button>
      </div>
    </>
  );
};


export default AdultAccessories;
